import styled from 'styled-components';
import { Spin, Statistic } from 'antd';
import { useSummaryData } from '../../../hooks/data/useSummaryData';
import { useTranslation } from 'react-i18next';
import { InfoPopoverButton } from '../../InfoPopoverButton';

const SideMenuSummary = () => {
  const { isLoading, agentCount } = useSummaryData();
  const { t } = useTranslation();

  return (
    <Spin spinning={isLoading}>
      <Statistic
        title={
          <TitleContainer>
            <ItemTitle>{t('targetAgentCount')}</ItemTitle>
            <InfoPopoverButton
              content={t('additionalInfos.targetAgentCount', {
                returnObjects: true,
              })}
            />
          </TitleContainer>
        }
        value={agentCount ?? '-'}
        suffix={<ItemSuffix>{t('unit.agent')}</ItemSuffix>}
        loading={isLoading}
      />
    </Spin>
  );
};

export { SideMenuSummary };

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const ItemTitle = styled.div`
  color: #595959;
`;

const ItemSuffix = styled.div`
  font-size: 60%;
`;
